import React, { useEffect, useState, useRef } from "react";
import { node, string } from "prop-types";
import { Col, Container, Row } from "../Grid";
import DropdownTitle from "../Dropdown/Title";
import DropdownBody from "../Dropdown/Body";
import NavbarItem from "../Navbar/Item";
import NavbarItemLink from "../Navbar/Link";
import Icon from "../Icon";
import { classes } from "../utils/classes";

function useDropdown() {
	const [isOpen, setIsOpen] = useState(false);
	const toggleList = event => {
		if (!event.target.closest(".header__search")) {
			setIsOpen(!isOpen);
		}
	};
	return [isOpen, setIsOpen, toggleList];
}

function useOnClickOutside(ref, handler) {
	useEffect(() => {
		const listener = event => {
			if (!ref.current || ref.current.contains(event.target)) {
				return;
			}

			handler(event);
		};

		document.addEventListener("mousedown", listener);
		document.addEventListener("touchstart", listener);

		return () => {
			document.removeEventListener("mousedown", listener);
			document.removeEventListener("touchstart", listener);
		};
	}, [ref, handler]);
}

const NavbarSearch = ({ className = "", children }) => {
	const [isOpen, setIsOpen, toggleList] = useDropdown();
	const ref = useRef();
	useOnClickOutside(ref, () => setIsOpen(false));
	return (
		<NavbarItem
			forwardRef={ref}
			itemIcon="search"
			secondary
			className={classes("dropdown", className, isOpen && "dropdown--open")}
			onClick={toggleList}
		>
			<DropdownTitle Tag={NavbarItemLink} triangle={false}>
				<Icon name="search" />
			</DropdownTitle>
			<DropdownBody isOpen={isOpen} utility={{ bgColor: "black--10" }} className="header__search">
				<Container>
					<Row>
						<Col>
							<div className="search-form">{children}</div>
						</Col>
					</Row>
				</Container>
			</DropdownBody>
		</NavbarItem>
	);
};

NavbarSearch.propTypes = {
	className: string,
	children: node.isRequired,
};

export default NavbarSearch;
